<template>
    <div
        id="sideNavBarCanvas"
        ref="navCanvas"
        class="offcanvas offcanvas-start m-0 p-0 mobile-side-nav"
        tabindex="-1"
        aria-label="Navigation"
    >
        <div ref="navBody" class="offcanvas-body m-0 p-0">
            <SideNavContent @hide-canvas="hideNavCanvas" />
        </div>
    </div>
</template>

<script>
import { Offcanvas } from "bootstrap";
import SideNavContent from "./common/SideNavContent.vue";
import { hideMobileNavigation } from "@/services/sidebarFocus";

export default {
    components: { SideNavContent },
    mounted() {
        this.offcanvasInstance = new Offcanvas(this.$refs.navCanvas);
        // Drive the global sidebarOpen flag from the offcanvas's own lifecycle so
        // system bar styling stays correct regardless of how it's opened/dismissed.
        this.onShow = (event) => {
            // Bootstrap's window-load handler also shows .offcanvas.show.
            // That class remains during hide; reject a late load or repeated
            // launcher activation until the closing transition has finished.
            if (this.$refs.navCanvas.classList.contains("hiding")) {
                event.preventDefault();
                return;
            }
            this.returnFocusTo = event.relatedTarget || document.activeElement;
            // The drawer stays mounted between visits; start each opening at
            // the top before its slide-in transition makes the content visible.
            this.$refs.navBody.scrollTop = 0;
        };
        this.onShown = () => this.$store.commit("setSidebarOpen", true);
        this.onHidden = () => {
            this.$store.commit("setSidebarOpen", false);
            const target = this.returnFocusTo;
            this.returnFocusTo = null;
            const focus = document.activeElement;
            if (
                target?.isConnected &&
                target.getClientRects().length &&
                !this.$store.state.commandPaletteOpen &&
                (focus === document.body || this.$refs.navCanvas.contains(focus))
            ) {
                target.focus({ preventScroll: true });
            }
        };
        this.$refs.navCanvas.addEventListener("show.bs.offcanvas", this.onShow);
        this.$refs.navCanvas.addEventListener("shown.bs.offcanvas", this.onShown);
        this.$refs.navCanvas.addEventListener("hidden.bs.offcanvas", this.onHidden);
    },
    beforeUnmount() {
        hideMobileNavigation();
        // Settle the closing callbacks while the element is still attached so
        // Bootstrap releases its document scroll lock and focus trap.
        this.$refs.navCanvas?.dispatchEvent(new Event("transitionend"));
        this.offcanvasInstance?.dispose();
        this.$refs.navCanvas?.removeEventListener("show.bs.offcanvas", this.onShow);
        this.$refs.navCanvas?.removeEventListener("shown.bs.offcanvas", this.onShown);
        this.$refs.navCanvas?.removeEventListener("hidden.bs.offcanvas", this.onHidden);
        this.$store.commit("setSidebarOpen", false);
    },
    methods: {
        hideNavCanvas() {
            hideMobileNavigation();
        }
    }
};
</script>

<style scoped>
.mobile-side-nav {
    z-index: 20000;
    overflow-x: hidden;
    background-color: var(--forkto-app-ground);
    scrollbar-width: none;
}

.mobile-side-nav::-webkit-scrollbar {
    display: none;
}

</style>
